import { render, staticRenderFns } from "./OrderScoreSidebar.vue?vue&type=template&id=69a05528&"
import script from "./OrderScoreSidebar.vue?vue&type=script&lang=js&"
export * from "./OrderScoreSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OrderScoreSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports